import React from 'react';

class FooterSocialicons extends React.Component {
    getSocialLink = (icon) => {
        switch(icon.title){
            case "Twitter":
                return <li  key={icon.title}> <a href={icon.url} aria-label="Follow us on Twitter"><span className="fab fa-lg fa-twitter-square" /></a> </li>
            case "YouTube":
                return <li  key={icon.title}> <a href={icon.url} aria-label="YouTube"><span className="fab fa-lg fa-youtube" /></a> </li>
            case "Facebook":
                return  <li key={icon.title}> <a href={icon.url} aria-label="Find us on facebook"><span className="fab fa-lg fa-facebook-square" /></a> </li>
            case "LinkedIn":
                return <li  key={icon.title}>  <a href={icon.url} aria-label="LinkedIn"><span className="fab fa-lg fa-linkedin" /></a>  </li>
        }
    }
  render() {
    return (
        <ul className="social-media-icons">
          {this.props.IconData.items.map((icon) => (
            this.getSocialLink(icon)
           ))
          }
        </ul>
    ) 
  }
}

export default FooterSocialicons;
